import React from 'react';
import styles from './PFSPartnersIndex.module.css';
import ContentContainer from '../ContentContainer/ContentContainer';
import { useBreadcrumb } from '../../hooks/useBreadcrumb';
import PFSServiceCard from '../PFSServiceCard/PFSServiceCard';
import ascendLogo from '../PFSAscend/Ascend_logo.png';
import agencyTransformLogo from '../PFSAgencyTransform/AgencyTransform_logo.png';
import PremierLogo from '../PFSPremierPartner/PremierLogo.png';
import CAALogo from '../PFSCombinedAgents/CAA_Stripe23-Web.png';
import MRCLogo from '../PFSMarketRetrievers/MRC-Logo-Stacked.png';
import VIAALogo from '../PFSVIAA/VIAA_logo.png';
import PIIBLogo from '../PFSPIIB/PIIB_logo.png';

export const PartnersIndexBreadcrumb = {
  label: 'Who We Trust',
  url: '/who-we-trust',
};

const PFSPartnersIndex = () => {
  useBreadcrumb([PartnersIndexBreadcrumb]);

  return (
    <div className={styles.PfsPartnersIndex} data-testid="PFSPartnersIndex">
      <ContentContainer>
        <center>
          <h1>PFS Global: Who We Trust</h1>
        </center>
        <center>
          <p>
            We look forward to collaborating with you! If you're interested in
            partnering with PFS Global, please contact us at{' '}
            <a className={styles.PfsEmail} href="mailto:info@pfsonline.com">
              Info@pfsonline.com
            </a>
            . Our team will respond promptly to discuss how we can work
            together.
          </p>
        </center>
        <br />
        <br />
        <br />
        <section className={styles.ServiceCardSection}>
          <div className={styles.ServiceCardContainer}>
            <PFSServiceCard
              icon={<img alt="Ascend" src={ascendLogo} width="128em" />}
              subtitle="Technology"
              title="Ascend"
              url="/who-we-trust/ascend"
            />
          </div>
          <div className={styles.ServiceCardContainer}>
            <PFSServiceCard
              icon={<img alt="Agency Transformation" src={agencyTransformLogo} width="128em" />}
              subtitle="Service Provider"
              title={["Agency", "Transformation"]}
              url="/who-we-trust/agency-transform"
            />
          </div>
          <div className={styles.ServiceCardContainer}>
            <PFSServiceCard
              icon={<img alt="Premier Computer Consulting" src={PremierLogo} width="168em" />}
              subtitle="Service Provider"
              title="Premier Computer Consulting"
              url="/who-we-trust/premier"
            />
          </div>
          <div className={styles.ServiceCardContainer}>
            <PFSServiceCard
              icon={<img alt="Combined Agents of America" src={CAALogo} width="128em" />}
              subtitle="Network"
              title="Combined Agents of America"
              url="/who-we-trust/combined-agents-of-america"
            />
          </div>
          <div className={styles.ServiceCardContainer}>
            <PFSServiceCard
              icon={<img alt="Market Retrievers" src={MRCLogo} width="168em" />}
              subtitle="Service Provider"
              title="Market Retrievers"
              url="/who-we-trust/market-retrievers"
            />
          </div>
          <div className={styles.ServiceCardContainer}>
            <PFSServiceCard
              icon={<img alt="Valley Insurance Agency Alliance" src={VIAALogo} width="168em" />}
              subtitle="Network"
              title={["Valley Insurance", "Agency Alliance"]}
              url="/who-we-trust/viaa"
            />
          </div>
          <div className={styles.ServiceCardContainer}>
            <PFSServiceCard
              icon={<img alt="PIIB" src={PIIBLogo} width="128em" style={{ maxHeight: '6.18em' }} />}
              subtitle="Network"
              title="Pacific Interstate Insurance Brokers"
              url="/who-we-trust/piib"
            />
          </div>
        </section>

        <br />
        <br />
        <br />
        <br />
        <br />
      </ContentContainer>
    </div>
  );
};

PFSPartnersIndex.propTypes = {};

export default PFSPartnersIndex;
